// extracted by mini-css-extract-plugin
module.exports = {"view":"View_view___UzEh","view--secondary":"View_view--secondary__2msLR","content-wrap":"View_content-wrap__2-8Q2"};